import { useState } from 'react';

import { GroupedOption } from '../../../hooks/useRiderOptions';

export function useRiderAgeIntegrityChecker() {
  const [openAgeWarningModal, setAgeWarningModal] = useState(false);
  const [openAgeAdvisoryModal, setAgeAdvisoryModal] = useState(false);

  const checkAgeIntegrity = (waypoints: WaypointFormType[], ridersOnRide: GroupedOption[]) => {
    if (!waypoints.length) {
      return true;
    }

    const getRiderById = (id: string) => ridersOnRide.find((rider) => rider.id === id);

    let ridersStillOnRide: GroupedOption[] = [];

    const isPickupRoute = waypoints[0].anchor === true;
    const isDropoffRoute = waypoints[waypoints.length - 1].anchor === true;
    const hasRiderAssistant = waypoints.some((w) => w.isRiderAssistant);

    for (let i = 0; i < waypoints.length; i++) {
      const { passengerIds } = waypoints[i];

      if (isPickupRoute) {
        if (i === 0) {
          // At the first waypoint, all passengers are picked up
          ridersStillOnRide = passengerIds
            .map((id) => getRiderById(id))
            .filter((rider): rider is GroupedOption => rider !== undefined);
        } else {
          // Remove dropped-off passengers at subsequent waypoints
          ridersStillOnRide = ridersStillOnRide.filter((rider) => rider.id && !passengerIds.includes(rider.id));
        }
      } else if (isDropoffRoute) {
        // For dropoff routes:
        // Add picked-up passengers to the ride at each waypoint (except the last one)
        if (i !== waypoints.length - 1) {
          const pickedUpRiders = passengerIds
            .map((id) => getRiderById(id))
            .filter((rider): rider is GroupedOption => rider !== undefined);

          ridersStillOnRide = [...ridersStillOnRide, ...pickedUpRiders];
        } else {
          // The last waypoint (anchor true) means all passengers are dropped off
          ridersStillOnRide = [];
        }
      }

      // Check if there is any rider under 3 (hard block) or exactly 3 (advisory only) on the ride
      const under3Rider = ridersStillOnRide.find((rider) => rider?.age !== undefined && rider.age < 3);
      const age3Rider = ridersStillOnRide.find((rider) => rider?.age !== undefined && rider.age === 3);

      if (!hasRiderAssistant && (under3Rider || age3Rider)) {
        const hasAccompanyingRider = ridersStillOnRide.some((rider) => rider?.age !== undefined && rider.age >= 7);

        // If no one 7 or older is on the ride, hard-block riders under 3 and advise on solo 3-year-olds
        if (!hasAccompanyingRider) {
          if (under3Rider) {
            setAgeWarningModal(true);
          } else {
            setAgeAdvisoryModal(true);
          }

          return false;
        }
      }
    }

    return true;
  };

  return {
    openAgeWarningModal,
    setAgeWarningModal,
    openAgeAdvisoryModal,
    setAgeAdvisoryModal,
    checkAgeIntegrity,
  };
}
